// Shared helpers for parsing and displaying salary ranges
export const parseSalary = (salaryStr: string): [number, number] => {
  if (!salaryStr) return [0, 999999];

  const cleaned = salaryStr.replace(/[€\s.,]/g, '');
  const rangeMatch = cleaned.match(/(\d+)\s*-\s*(\d+)/);
  if (rangeMatch) {
    return [parseInt(rangeMatch[1], 10), parseInt(rangeMatch[2], 10)];
  }

  const singleMatch = cleaned.match(/(\d+)/);
  if (singleMatch) {
    const num = parseInt(singleMatch[1], 10);
    if (num < 1000) return [0, 999999];
    return [num, num];
  }

  return [0, 999999];
};

const formatCurrency = (num: number): string => `€${num.toLocaleString('nl-NL')}`;

export const formatSalaryDisplay = (salary: string, language: 'nl' | 'en' = 'nl'): string => {
  if (!salary) {
    return language === 'nl' ? 'Salaris niet opgegeven' : 'Salary not specified';
  }

  const [min, max] = parseSalary(salary);
  const unparsable = min === 0 && max === 999999;

  if (unparsable) return salary;
  if (min === max) return formatCurrency(min);
  return `${formatCurrency(min)} - ${formatCurrency(max)}`;
};
